import { TransformType } from './transformType';
import { DataFarmType } from './dataFarmType';
import { v4 as uuidv4 } from 'uuid';
import { ExportSaveConfigModel } from '../viewModels/exportViewModel';

export abstract class DataTransform<T> {
    guid?: string;
    id?: number;
    index: number;
    name: string;
    isEnabled: boolean;
    /** Per-transformer bypass toggle on the Node page (distinct from isEnabled, which serves
     *  an unrelated purpose already in use elsewhere). false = skip this transformer's
     *  execution entirely and pass its input straight through unchanged as its output. */
    run = true;
    description: string;
    /** Analyst-authored free-form rich-text description of this transformer, persisted as sanitized HTML. */
    analystDescription?: string;
    transformType: TransformType;
    transformConfig: T;
    dataFarmType?: DataFarmType;
    inputTransformGuid?: string;
    forceRun = false;
    nodeID?: string;
    export?:ExportSaveConfigModel;

    /** Pre-compiled operations plan for the fast engine path; null = not yet compiled.
     *  Lives outside transformConfig so it never enters the transformConfig hash used for caching. */
    compiledConfig?: any = null;
    /** SHA-256 hash of the compiled operations plan; null = not yet compiled. */
    compiledConfigHash?: string = null;
    /** UTC timestamp of the last successful compile. */
    compiledAt?: Date = null;
    /** The compiledConfigHash value "Audit Compiler Quality" was actually run against;
     *  null = never audited. Written by Flask's /audit endpoint directly, not this app. */
    lastAuditHash?: string = null;
    /** "match" or "mismatch" -- the outcome of the audit run against lastAuditHash.
     *  Null if never audited. */
    lastAuditResult?: string = null;

    constructor(id: number, name: string, index: number, transformType: TransformType, nodeID: string) {
        this.guid = uuidv4();
        this.id = id;
        this.name = name;
        this.index = index;
        this.transformType = transformType;
        this.nodeID = nodeID;
    }

    abstract setRunAll(runAll: boolean): void;
}
